import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import { Modal, Grid } from '@mui/material';
import DriveWithUsOne from '../DriveWithUsForm/DriveWithUsOne';
import DriveWithUsTwo from '../DriveWithUsForm/DriveWithUsTwo';
import DriveWithUsThree from '../DriveWithUsForm/DriveWithUsThree';
import DriveWithUsFour from '../DriveWithUsForm/DriveWithUsFour';
import DriveWithUsSix from '../DriveWithUsForm/DriveWithUsSix';
import { styled } from "@mui/material/styles"
import Check from '@mui/icons-material/Check';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import ThankYouComponent from '../ThankYouComponent/ThankYouComponent';
import ProgressBar from '../ProgressBar/ProgressBar';
import DriveWithUsEight from 'Component/DriveWithUsForm/DriveWithUsEight';
import DriveWithUsOne_2 from 'Component/DriveWithUsForm/DriveWithUsOne_2';
import DriveWithUsTen from 'Component/DriveWithUsForm/DriveWithUsTen';
import DriveWithUsEleven from 'Component/DriveWithUsForm/DriveWithUsEleven';
import VideoPlayer from 'Component/VideoPlayer';
const steps = ['1', '2', '3', "4", "5", "6", "7", "8", "9"];



const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#021b38',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#021b38',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#97c11e',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));
const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#97c11e',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#021b38',
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#021b38',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));



export default function DriveWithUs({ SetValue }) {
  const [progress, setProgress] = React.useState(0)
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});

  const [driveUsData, setDriveUsData] = React.useState({
    started_from: new Date().toISOString().split('T')[0],
    first_name: "",
    last_name: "",
    company: "",
    address: "",
    apt: "",
    city: "",
    state: "",
    zip_code: "",
    phone: "",
    email: "",
    password: "",
    driver_license: "",
    driver_license_expiry: "",
    driver_license_number: "",
    tlc_license: "",
    tlc_license_expiry: "",
    tlc_license_number: "",
    profile_pic: "",
    vehicle_pic: "",
    vehicle_reg_pic: "",
    plate_number: "",
    pin_number: "",
    vehicle_reg_expiry: "",
    car_inspec_pic: "",
    car_inspec_expiry: "",
    diamond_sticker_pic: "",
    diamond_sticker_expiry: "",
    diamond_sticker_number: "",
    liability_insurance_pic: "",
    liability_insurance_expiry: "",
    social_security_pic: "",
    fh1_insurance_pic: ""
  })


  function QontoStepIcon(props) {
    const { active, completed, className } = props;


    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {completed ? (
          <Check className="QontoStepIcon-completedIcon" />
        ) : (
          <div className="QontoStepIcon-circle" />
        )}
      </QontoStepIconRoot>
    );
  }
  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };
  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
        // find the first step that has been completed
        steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      SetValue(false)
    } else {


      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      let keys = Object.keys(completed);
      if (keys.length > 0) {
        let lastElement = keys[keys.length - 1]
        delete completed[lastElement]
      }
    }
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };
  React.useEffect(() => {
    const interval = setInterval(() => {
      const progress = localStorage.getItem("progress")
      if (progress !== null) {
        setProgress(progress)

      }
    }, 100)
    return () => {
      clearInterval(interval)
    }
  }, [])
  return (
    <Box sx={{ width: '100%' }}>

      {/* <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton color="inherit" onClick={handleStep(index)}>
              
            </StepButton>
          </Step>
        ))}
      </Stepper> */}



      <Stepper alternativeLabel sx={{ display: allStepsCompleted() ? "none" : "flex" }} activeStep={activeStep} connector={<QontoConnector />}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={QontoStepIcon}></StepLabel>
          </Step>
        ))}
      </Stepper>

      <div>
        {allStepsCompleted() ? (
          <React.Fragment>
            {progress < 100 ?

              <Box sx={{ display: "flex", justifyContent: "center" }}  >
                <ProgressBar progress={progress} />
              </Box>
              :
              <Modal open={true} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
                <ThankYouComponent />
              </Modal>
            }
          </React.Fragment>
        ) : (

          <React.Fragment>






            {activeStep === 0 ? <DriveWithUsOne handleBack={handleBack} handleComplete={handleComplete} driveUsData={driveUsData} setDriveUsData={setDriveUsData} /> :
              activeStep === 1 ? <DriveWithUsOne_2 handleBack={handleBack} handleComplete={handleComplete} driveUsData={driveUsData} setDriveUsData={setDriveUsData} /> :
                activeStep === 2 ? <DriveWithUsTwo handleBack={handleBack} handleComplete={handleComplete} driveUsData={driveUsData} setDriveUsData={setDriveUsData} /> :
                  activeStep === 3 ? <DriveWithUsThree handleBack={handleBack} handleComplete={handleComplete} driveUsData={driveUsData} setDriveUsData={setDriveUsData} /> :
                    activeStep === 4 ? <DriveWithUsFour handleBack={handleBack} handleComplete={handleComplete} driveUsData={driveUsData} setDriveUsData={setDriveUsData} /> :
                      activeStep === 5 ? <DriveWithUsSix handleBack={handleBack} handleComplete={handleComplete} driveUsData={driveUsData} setDriveUsData={setDriveUsData} /> :
                        activeStep === 6 ? <DriveWithUsEight handleBack={handleBack} handleComplete={handleComplete} driveUsData={driveUsData} setDriveUsData={setDriveUsData} /> :
                          activeStep === 7 ? <DriveWithUsTen handleBack={handleBack} handleComplete={handleComplete} driveUsData={driveUsData} setDriveUsData={setDriveUsData} /> :
                            activeStep === 8 ? <DriveWithUsEleven handleBack={handleBack} handleComplete={handleComplete} driveUsData={driveUsData} setDriveUsData={setDriveUsData} /> :
                              ""}



          </React.Fragment>

        )}
      </div>







    </Box>
  );
}